import {GraphQLError} from 'graphql';

export function hasNetworkTokenExpiredError(errors?: readonly GraphQLError[]) {
    if (!errors) return false;
    const tokenExpiredError = errors.find(item => item.message === 'Expired token');
    return !!tokenExpiredError;
}
